import { render, staticRenderFns } from "./tabela-alunos.vue?vue&type=template&id=d4ea7c18"
import script from "./tabela-alunos.vue?vue&type=script&lang=js"
export * from "./tabela-alunos.vue?vue&type=script&lang=js"
import style0 from "./tabela-alunos.vue?vue&type=style&index=0&id=d4ea7c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports